export default "__VITE_ASSET__Bu8Uj3_x__"